import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNightSky = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 190 190",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M95.0363 159.768C130.687 159.768 159.588 130.867 159.588 95.2165C159.588 59.5654 130.687 30.6646 95.0363 30.6646C59.3852 30.6646 30.4844 59.5654 30.4844 95.2165C30.4844 130.867 59.3852 159.768 95.0363 159.768Z",
			fill: "#005BE4"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M95.0003 175.569C139.498 175.569 175.57 139.497 175.57 94.9998C175.57 50.5024 139.498 14.4302 95.0003 14.4302C50.5029 14.4302 14.4307 50.5024 14.4307 94.9998C14.4307 139.497 50.5029 175.569 95.0003 175.569Z",
			fill: "#005BE4"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M95 190C147.467 190 190 147.467 190 95C190 42.533 147.467 0 95 0C42.533 0 0 42.533 0 95C0 147.467 42.533 190 95 190Z",
			fill: "#005BE4"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 115,
			cy: 47,
			r: 2,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 48,
			cy: 62,
			r: 2,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 150,
			cy: 76,
			r: 2,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 67,
			cy: 100,
			r: 2,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 122,
			cy: 116,
			r: 2,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 67,
			cy: 142,
			r: 2,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.1632 53.8378C74.1632 53.8378 81.0001 55.5285 81.0001 57.0009C81.0001 58.4734 74.1632 60.1641 74.1632 60.1641C74.1632 60.1641 72.4726 67.0009 71.0001 67.0009C69.5276 67.0009 68.1774 60.1641 67.837 60.1641C67.4966 60.1641 61.0001 58.4734 61.0001 57.0009C61.0001 55.5285 67.837 53.8378 67.837 53.8378C67.837 53.8378 69.5276 47.0009 71.0001 47.0009C72.4726 47.0009 74.1632 53.8378 74.1632 53.8378Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.163 131.838C110.163 131.838 117 133.528 117 135.001C117 136.473 110.163 138.164 110.163 138.164C110.163 138.164 108.473 145.001 107 145.001C105.528 145.001 104.177 138.164 103.837 138.164C103.497 138.164 97.0001 136.473 97.0001 135.001C97.0001 133.528 103.837 131.838 103.837 131.838C103.837 131.838 105.528 125.001 107 125.001C108.473 125.001 110.163 131.838 110.163 131.838Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.8979 103.103C49.8979 103.103 54.0001 104.117 54.0001 105.001C54.0001 105.884 49.8979 106.898 49.8979 106.898C49.8979 106.898 48.8835 111.001 48.0001 111.001C47.1166 111.001 46.3064 106.898 46.1022 106.898C45.8979 106.898 42.0001 105.884 42.0001 105.001C42.0001 104.117 46.1022 103.103 46.1022 103.103C46.1022 103.103 47.1166 99.0006 48.0001 99.0006C48.8835 99.0006 49.8979 103.103 49.8979 103.103Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M102.24 97.7608C102.24 97.7608 106 98.6907 106 99.5005C106 100.31 102.24 101.24 102.24 101.24C102.24 101.24 101.31 105.001 100.5 105.001C99.6902 105.001 98.9476 101.24 98.7603 101.24C98.5731 101.24 95.0001 100.31 95.0001 99.5005C95.0001 98.6907 98.7603 97.7608 98.7603 97.7608C98.7603 97.7608 99.6902 94.0005 100.5 94.0005C101.31 94.0005 102.24 97.7608 102.24 97.7608Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149.24 112.761C149.24 112.761 153 113.691 153 114.501C153 115.31 149.24 116.24 149.24 116.24C149.24 116.24 148.31 120.001 147.5 120.001C146.69 120.001 145.948 116.24 145.76 116.24C145.573 116.24 142 115.31 142 114.501C142 113.691 145.76 112.761 145.76 112.761C145.76 112.761 146.69 109.001 147.5 109.001C148.31 109.001 149.24 112.761 149.24 112.761Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.77 77.231C115.77 77.231 125 79.5134 125 81.5013C125 83.4891 115.77 85.7715 115.77 85.7715C115.77 85.7715 113.488 95.0013 111.5 95.0013C109.512 95.0013 107.689 85.7715 107.23 85.7715C106.77 85.7715 98.0002 83.4891 98.0002 81.5013C98.0002 79.5134 107.23 77.231 107.23 77.231C107.23 77.231 109.512 68.0013 111.5 68.0013C113.488 68.0013 115.77 77.231 115.77 77.231Z",
			fill: "white"
		})
	]
});
export default SvgNightSky;
